import { render, staticRenderFns } from "./DistributePurchaseInvoiceRows.vue?vue&type=template&id=0faf4d56"
import script from "./DistributePurchaseInvoiceRows.vue?vue&type=script&lang=ts"
export * from "./DistributePurchaseInvoiceRows.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports